import { useSelector } from "react-redux";
import useCustomers from "./useCustomers";
import CustomerReviewAction from "@common/redux/actions/CustomerReviewAction";
import CustomerReviewModalAction from "@common/redux/actions/CustomerReviewModalAction";
import useCustomerReviewsFilters from "./useCustomerReviewsFilters";
import { fromDateTime, toDateTime } from "../helpers/datetime";

const useInteractions = () => {
  const { getRecords, interactionDateRange, reviewStatusIds } = useCustomers();

  const { selectedRecord, selectedSummaryRecord } = useSelector((state) =>
    CustomerReviewModalAction.getStatePath(state),
  );

  const { id, triggeredByAlert, customerInteractionReasonId } =
    useCustomerReviewsFilters();

  const setCustomerReviewState = CustomerReviewAction.dispatch;
  const setCustomerReviewModalState = CustomerReviewModalAction.dispatch;

  const getCustomerInteractions = () => {
    if (!selectedSummaryRecord?.customer?.id) {
      return;
    }

    const fnCallback = (records, totalRecords, reviewStatusCounts) => {
      const matchingRecord = records.find(
        (record) => record.id === selectedRecord?.id,
      );
      setCustomerReviewModalState({
        records,
        totalRecords,
        selectedRecord: matchingRecord,
      });
      setCustomerReviewState({ reviewStatusCounts });
    };

    getRecords(
      {
        id: id || null,
        customerId: selectedSummaryRecord.customer.id,
        reviewStatusIds,
        pageNumber: 1,
        pageSize: 50,
        byCustomer: false,
        interactionDateFrom: fromDateTime(interactionDateRange),
        interactionDateTo: toDateTime(interactionDateRange),
        customerInteractionReasonId,
        triggeredByAlert,
      },
      fnCallback,
    );
  };

  return {
    interactionDateRange,
    getCustomerInteractions,
  };
};

export default useInteractions;
